export const manifest = {
  screens: {
    scr_7722vn: { name: "Welcome", route: "/", position: {"x":160,"y":220} },
    scr_m2g6aw: { name: "AI Chat", route: "/chat", position: {"x":160,"y":4180} },
    scr_aq8q18: { name: "Shopping List", route: "/list", position: {"x":160,"y":2200} },
    scr_74hhx7: { name: "Product Details", route: "/product", position: {"x":1560,"y":2200} },
  },
  sections: {
    sec_uq8kg1: { name: "Onboarding", x: 0, y: 0, width: 1520, height: 1180 },
    sec_hpuovy: { name: "Shopping Flow", x: 0, y: 1980, width: 2920, height: 1180 },
    sec_jjzyyh: { name: "AI Assistant", x: 0, y: 3960, width: 1520, height: 1180 },
    sec_lru08i: { name: "Store Navigation", x: 0, y: 5940, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_uq8kg1", children: [
      { kind: "screen", id: "scr_7722vn" },
    ] },
    { kind: "section", id: "sec_hpuovy", children: [
      { kind: "screen", id: "scr_aq8q18" },
      { kind: "screen", id: "scr_74hhx7" },
    ] },
    { kind: "section", id: "sec_jjzyyh", children: [
      { kind: "screen", id: "scr_m2g6aw" },
    ] },
    { kind: "section", id: "sec_lru08i", children: [
      { kind: "screen", id: "scr_j6lq7d" },
    ] },
  ],
}
